import React from 'react';
import "./style.scss";
import {Link, useSearchParams} from "react-router-dom";


export const InternalErrorViewView = () => {

    const [searchParams, setSearchParams] = useSearchParams();


    return (
        <div className="error-view-container">
            <div className="error-view">
                <div className="error-view-code">
                    <h1>500</h1>
                </div>
                <h2 className="error-view-header">Произошла ошибка</h2>
                <p className="error-view-content">
                    На странице произошла необработанная внутренняя ошибка.&nbsp;
                    <br></br>
                    <Link reloadDocument to={(searchParams.get('requestedPage') ?? "/")}>Повторите попытку</Link> или обратитесь в службу поддержки.
                </p>
            </div>
        </div>
    )
};